<template>
    <div class="w-full flex flex-col font-fira info-bg relative">
        <div id="insp" class="self-center font-fira text-black mid-slogan ">
            <h1 class="font-fira text-4xl font-hairline"><span class="uppercase">színezd</span><br>
                <span class="font-fira rotate inline-block text-4xl font-normal">ki</span> az <span
                        class="inline-block text-4xl font-normal">álmaidat!</span></h1>
        </div>
        <div class="flex justify-center flex-wrap items-center">
            <transition name="left" mode="out-in" appear>
                <webdesign :appear="appear" class="card m-4 cursor-pointer cardid"></webdesign>
            </transition>
            <transition name="up" mode="out-in" appear>
                <webfejlesztes :appear="appear" class="card m-4 cursor-pointer cardid"></webfejlesztes>
            </transition>
            <transition name="bottom" mode="out-in" appear>
                <grafika :appear="appear" class="card m-4 cursor-pointer cardid"></grafika>
            </transition>
            <transition name="right" mode="out-in" appear>
                <fotozas :appear="appear" class="card m-4 cursor-pointer cardid"></fotozas>
            </transition>
        </div>
        <transition name="flip">
            <div>

            </div>
        </transition>

    </div>
</template>

<script>
import webdesign from './Webdesign'
import webfejlesztes from './Webfejlesztes'
import grafika from './Grafika'
import fotozas from './Fotozas'

export default {
  components: {webdesign, webfejlesztes, grafika, fotozas},
  props: ['propScroll', 'propPos'],
  data () {
    return {
      svg: false,
      appear: false,
      flip1: true
    }
  },
  watch: {
    propScroll () {
      if (this.propPos - this.propScroll <= 200) {
        this.appear = true
      }
    }
  }

}
</script>
<style lang="scss" scoped>

    .mid-slogan {
        margin-top: 100px;
        margin-bottom: 100px;
        margin-left: 20%;
        @media (min-width: 992px) {
            margin-left: 400px;
        }
    }

    svg {
        height: 3.5rem;
    }
    .rotate {
        transform: rotate(-90deg);
    }
    .card {
        max-width: 400px;
        border-radius: 5px;
        height: 280px;
        width: 22%;
        flex-grow: 2;
        @media (max-width: 1200px) {
            width: 35%;
            height: 200px;
        }
        @media (max-width: 768px) {
            width: 100%;
            height: 150px;
        }
        @media (max-width: 576px) {
           height: 220px;
        }
    }

    .left-enter-active {
        animation: slide-right .8s ease-out forwards;
    }

    .bottom-enter-active {
        animation: slide-up .8s ease-out forwards;
    }

    .up-enter-active {
        animation: slide-down .8s ease-out forwards;
    }

    .right-enter-active {
        animation: slide-left .8s ease-out forwards;
    }

    @keyframes slide-right {
        0% {
            transform: translateX(-900px);
        }
        100% {
            transform: translateX(0);
        }
    }

    @keyframes slide-up {
        0% {
            transform: translateY(900px);
        }
        100% {
            transform: translateX(0);
        }
    }

    @keyframes slide-down {
        0% {
            transform: translateY(-900px);
        }
        100% {
            transform: translateX(0);
        }
    }

    @keyframes slide-left {
        0% {
            transform: translateX(900px);
        }
        100% {
            transform: translateX(0);
        }
    }

    .outlineAnimation {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
        animation: icon-animate-in 3s cubic-bezier(0.95, 0.05, 0.795, 0.035);
    }

    @keyframes icon-animate-in {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffest: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/InformationSection.vue